export const ID_TOKEN = 'id_token_safycity&MLDKDLM@0837890lkdqhdLMFJUIE725SM';

export function getToken()
{
  try
  {
    return getLocalStorage(ID_TOKEN);
  }
  catch(e)
  {
    return undefined;
  }
}

export function setLocalStorage(key, value) {
  try
  {
    localStorage.setItem(key, value);
    const verif = getLocalStorage(key);

    return verif !== null && verif !== undefined && verif === value;
  }
  catch(e)
  {
    return false;
  }

}

export function deleteLocalStorage(key) {
  try
  {
    localStorage.removeItem(key);
    return true;
  }
  catch(e)
  {
    return false;
  }
}

export function clearLocalStorage() {
  try
  {
    localStorage.clear();
    return true;
  }
  catch(e)
  {
    return false;
  }
}

export function getLocalStorage(key)
{
  try
  {
    return localStorage.getItem(key);
  }
  catch(e)
  {
    return undefined;
  }
}